'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$proto$UpdateUP(username, password) {
  this.a0s = null;
  this.a0r = null;
  this.a0s = username;
  this.a0r = password;
}
export { $c_Lpresto_types$proto$UpdateUP as $c_Lpresto_types$proto$UpdateUP };
$p = $c_Lpresto_types$proto$UpdateUP.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$proto$UpdateUP;
/** @constructor */
function $h_Lpresto_types$proto$UpdateUP() {
}
export { $h_Lpresto_types$proto$UpdateUP as $h_Lpresto_types$proto$UpdateUP };
$h_Lpresto_types$proto$UpdateUP.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$proto$UpdateUP)) {
    if ((this.a0s === x$0.a0s)) {
      var x = this.a0r;
      var x$2 = x$0.a0r;
      return ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 2;
});
$p.s = (function() {
  return "UpdateUP";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.a0s;
  }
  if ((n === 1)) {
    return this.a0r;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_types$proto$UpdateUP(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.mf)));
}
export { $isArrayOf_Lpresto_types$proto$UpdateUP as $isArrayOf_Lpresto_types$proto$UpdateUP };
var $d_Lpresto_types$proto$UpdateUP = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$proto$UpdateUP, "presto.types$proto$UpdateUP", ({
  mf: 1,
  bx: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$proto$UpdateUP as $d_Lpresto_types$proto$UpdateUP };
//# sourceMappingURL=presto.types$proto$-Update-U-P.js.map
